import { CrudList } from '../shared/CrudPage';
import { promotionService } from '@kss/api';
import type { Promotion, PromotionCreate, PromotionFilter } from '@kss/api';

export default function AllPromotions() {
  return (
    <CrudList<Promotion, PromotionCreate, PromotionFilter>
      title="Promotions"
      newLabel="New promotion"
      service={promotionService}
      idKey="promotionId"
      labelKey="name"
      basePath="/panel/promotions"
      columns={[
        { accessor: 'code', title: 'Code', width: 140 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'promotionType' as never, title: 'Type', width: 130 },
        { accessor: 'startDate' as never, title: 'Start', width: 120 },
        { accessor: 'endDate' as never, title: 'End', width: 120 },
      ]}
    />
  );
}
